"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
var certificateIcon = require('../images/font-awesome/certificate-solid.svg');
var cogIcon = require('../images/font-awesome/cog-solid.svg');
var CUSTOM_LINK_TEMPLATE = {
    markerSource: {
        fill: '#4b4a67',
        stroke: '#4b4a67',
        d: 'M0,3a3,3 0 1,0 6,0a3,3 0 1,0 -6,0',
        width: 6,
        height: 6,
    },
    markerTarget: {
        fill: '#4b4a67',
        stroke: '#4b4a67',
        d: 'm 20,5.88 -10.3,-5.95 0,5.6 -9.7,-5.6 0,11.82 9.7,-5.53 0,5.6 z',
        width: 20,
        height: 12,
    },
    renderLink: function () { return ({
        connection: {
            stroke: '#3c4260',
            'stroke-width': 2,
        },
        connector: { name: 'rounded' },
        label: {
            attrs: { text: { fill: '#3c4260' } },
        },
    }); },
};
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    workspace.getModel().importLayout({
        diagram: diagram,
        dataProvider: new index_1.SparqlDataProvider({
            endpointUrl: '/sparql',
            imagePropertyUris: [
                'http://collection.britishmuseum.org/id/ontology/PX_has_main_representation',
                'http://xmlns.com/foaf/0.1/img',
            ],
        }),
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    viewOptions: {
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
    },
    typeStyleResolver: function (types) {
        if (types.indexOf('http://www.w3.org/2000/01/rdf-schema#Class') !== -1) {
            return { icon: certificateIcon };
        }
        else if (types.indexOf('http://www.w3.org/2002/07/owl#Class') !== -1) {
            return { icon: certificateIcon };
        }
        else if (types.indexOf('http://www.w3.org/2002/07/owl#ObjectProperty') !== -1) {
            return { icon: cogIcon };
        }
        else if (types.indexOf('http://www.w3.org/2002/07/owl#DatatypeProperty') !== -1) {
            return { color: '#046380' };
        }
        else {
            return undefined;
        }
    },
    linkTemplateResolver: function (type) { return CUSTOM_LINK_TEMPLATE; },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
